import { useRef } from 'react';

export function useCurrentRefs<T>(items: T): React.MutableRefObject<T> {
  const refs = useRef<T>(items);
  refs.current = items;

  return refs;
}
